import { Fragment, useEffect, useState } from "react";
import SidebarIcon from "./SidebarIcon";
import SidebarLogo from "./SidebarLogo";
import SidebarMenu from "./SidebarMenu";
import DropdownList from "../../CommonElements/Dropdown";

const SideBarLayout = (props) => {
  // ==============================
  // States
  // ==============================
  const [width, setWidth] = useState(0);
  const [sidebartoogle, setSidebartoogle] = useState(true);

  // ==============================
  // Handlers
  // ==============================
  const handleScroll = () => {
    if (window.scrollY > 400) {
      document.querySelector(".sidebar-main").className =
        "sidebar-main hovered";
    } else {
      if (document.getElementById("sidebar-main"))
        document.querySelector(".sidebar-main").className = "sidebar-main";
    }
  };
  const handleResize = () => {
    setWidth(window.innerWidth - 500);
  };

  // ==============================
  // Effects
  // ==============================

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // ==============================
  // Render
  // ==============================
  return (
    <Fragment>
      <SidebarLogo
        sidebartoogle={sidebartoogle}
        setSidebartoogle={setSidebartoogle}
      />
      <SidebarIcon />
      <SidebarMenu
        props={props}
        sidebartoogle={sidebartoogle}
        width={width}
      />
      <span
        className="d-flex flex-fill align-items-end align-self-center d-md-none w-100 "
        style={{
          marginBottom: "48px",
          marginInlineStart: "50px",
          position: "sticky",
          bottom: "0",
        }}
      >
        <DropdownList />
      </span>
    </Fragment>
  );
};
export default SideBarLayout;
